/**
 * P3-42: ChallengesTab —— 挑战 tab React 实现。
 *
 * 结构对齐 `js/challenges.js:1234-1322`：
 * - ChallengePanel（resetMessage + 挑战按钮列表）
 * - ApplyPendingBtn
 * - ReservesPanel
 * - ShowChallengeEffectsBtn
 * - ChallengeEffectsPanel × N
 */
import { getGame } from "../../bridge/GameBridge";
import ApplyPendingBtn from "./ApplyPendingBtn";
import ChallengeEffectsPanel from "./ChallengeEffectsPanel";
import ChallengePanel from "./ChallengePanel";
import ReservesPanel from "./ReservesPanel";
import ShowChallengeEffectsBtn from "./ShowChallengeEffectsBtn";

export default function ChallengesTab() {
  const challenges = getGame()?.challenges?.challenges ?? [];

  return (
    <div className="tabInner Challenges">
      <ChallengePanel />
      <div style={{ marginBottom: "15px" }} />
      <ApplyPendingBtn />
      <ReservesPanel />
      <div style={{ marginBottom: "15px" }} />
      <ShowChallengeEffectsBtn />
      {challenges.map((challenge: { name: string }) => (
        <ChallengeEffectsPanel key={challenge.name} challengeName={challenge.name} />
      ))}
    </div>
  );
}
